import { render, staticRenderFns } from "./the-fitness-assessment.vue?vue&type=template&id=2e55f690&"
import script from "./the-fitness-assessment.vue?vue&type=script&lang=js&"
export * from "./the-fitness-assessment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports